import { SB } from '@play-co/replicant';

export const marketingSchema = {
  marketing: SB.map(SB.int().min(0)),
};
